import type { V2CreateAdminPropertyInput } from '@idc-forms/schemas/api-v2/admin-properties'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreatePropertyV2Mutation } from '../hooks/use-property-v2-mutations'
import { PropertyV2Form } from './property-v2-form'

type PropertyV2CreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo inmueble" contra la API v2: el mismo `PropertyV2Form` que la edición. */
export function PropertyV2CreatePanel({ onDone }: PropertyV2CreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreatePropertyV2Mutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: V2CreateAdminPropertyInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <PropertyV2Form
      submitLabel="Crear inmueble"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
